import React from "react";
import AuthUserContext from "./AuthUserContext";

export default function useAuthUser() {
  return React.useContext(AuthUserContext);
}
